import { Chips, Dropdown } from '@agro1desenvolvimento/react-components/dist/primereact-components';
import { BinaryOperator, UnaryOperator } from '@cubejs-client/core';
import { QueryBuilderRenderProps } from '@cubejs-client/react';
import React, { useMemo } from 'react';

const operators: Record<
  'string' | 'number' | 'time',
  { name: BinaryOperator | UnaryOperator, title: string }[]
> = {
  string: [
    { name: 'contains', title: 'Contem' },
    { name: 'notContains', title: 'Não contem' },
    { name: 'equals', title: 'Igual' },
    { name: 'notEquals', title: 'Diferente' },
    { name: 'set', title: 'Está definido' },
    { name: 'notSet', title: 'Não está definido' },
  ],
  number: [
    { name: 'equals', title: 'Igual' },
    { name: 'notEquals', title: 'Diferente' },
    { name: 'set', title: 'está definido' },
    { name: 'notSet', title: 'Não está definido' },
    { name: 'gt', title: '>' },
    { name: 'gte', title: '>=' },
    { name: 'lt', title: '<' },
    { name: 'lte', title: '<=' },
  ],
  time: [
    { name: 'equals', title: 'Igual' },
    { name: 'notEquals', title: 'Diferente' },
    { name: 'inDateRange', title: 'No intervalo' },
    { name: 'notInDateRange', title: 'Fora do intervalo' },
    { name: 'afterDate', title: 'Depois' },
    { name: 'beforeDate', title: 'Antes' },
  ],
};

const FilterGroup: React.FC<
  Pick<QueryBuilderRenderProps, 'filters' | 'updateFilters' | 'availableFilterMembers'>
> = ({ availableFilterMembers, filters, updateFilters }) => {
  const members = useMemo(
    () => availableFilterMembers.map((v) => v.members).flat(),
    [availableFilterMembers],
  );

  const onFilterChange = (
    value: string | undefined,
    filter: (typeof filters)[number],
  ) => {
    if (!value) {
      updateFilters.remove(filter);
      return;
    }

    updateFilters.update(
      filter,
      { ...filter, dimension: members.find(({ name }) => name === value)! },
    );
  };

  return (
    <>
      {filters.map((filter) => (
        <div key={filter.index} className="p-col">
          <div style={{ width: 'max-content' }}>
            <Dropdown
              placeholder="Filtro"
              options={members}
              className="p-mr-1"
              filter
              onChange={({ value }) => onFilterChange(value, filter)}
              showClear
              optionLabel="title"
              optionValue="name"
              value={filter.member}
            />
            <Dropdown
              options={operators[filter.dimension.type as keyof typeof operators]}
              className="p-mx-1"
              onChange={({ value }) => (
                updateFilters.update(
                  filter,
                  { ...filter, operator: value },
                )
              )}
              optionLabel="title"
              optionValue="name"
              value={filter.operator}
            />
            <Chips
              allowDuplicate={false}
              placeholder="Valores"
              className="p-ml-1"
              onAdd={({ value }) => {
                updateFilters.update(
                  filter,
                  { ...filter, values: [...(filter.values || []), value] },
                );
              }}
              onRemove={({ value }) => {
                updateFilters.update(
                  filter,
                  { ...filter, values: filter.values?.filter((v) => !value.includes(v)) },
                );
              }}
              value={filter.values}
            />
          </div>
        </div>
      ))}

      <div className="p-col-2">
        <Dropdown
          placeholder="Adicionar Filtro"
          options={members}
          style={{ width: '100%' }}
          filter
          onChange={({ value }) => (
            updateFilters.add({
              dimension: value,
              operator: operators[value.type as keyof typeof operators][0].name,
            })
          )}
          optionLabel="title"
        />
      </div>
    </>
  );
};

export default FilterGroup;
